let previousFocus = null;

function toggleUspDrawer(show, id = null) {
  const container = document.getElementById("usp-drawer-container");
  const overlay = document.getElementById("usp-drawer-overlay");
  const allDrawers = document.querySelectorAll("[id^='usp-drawer-id-']");
  if (!overlay) return;

  if (!show) {
    allDrawers.forEach((drawer) => {
      drawer.classList.remove("tw-translate-y-0", "md:tw-translate-x-0");
      drawer.classList.add("tw-translate-y-full", "md:tw-translate-x-[-100%]");
      overlay.classList.remove("tw-opacity-40");
      overlay.classList.add("tw-opacity-0");
      setTimeout(() => {
        drawer.style.display = "none";
        container.style.display = "none";
        overlay.style.display = "none";
      }, 550); // the css transition is 500 + a 50ms buffer
    });
    if (previousFocus) {
      previousFocus.focus();
      previousFocus = null;
    }
    document.removeEventListener("keydown", trapTabKey);
    document.removeEventListener("keydown", handleEscapeKey);
  } else if (id) {
    const drawer = document.getElementById(`usp-drawer-id-${id}`);
    if (drawer) {
      container.style.display = "block";
      drawer.style.display = "block";
      overlay.style.display = "block";
      overlay.classList.remove("tw-opacity-0");
      overlay.classList.add("tw-opacity-40");

      void drawer.offsetWidth;
      drawer.classList.remove(
        "tw-translate-y-full",
        "md:tw-translate-x-[-100%]"
      );
      drawer.classList.add("tw-translate-y-0", "md:tw-translate-x-0");

      previousFocus = document.activeElement;
      drawer.focus();
      document.addEventListener("keydown", trapTabKey);
      document.addEventListener("keydown", handleEscapeKey);
    }
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.disabled && !el.getAttribute("aria-hidden"));
}

function trapTabKey(e) {
  const activeDrawer = document.querySelector(
    '[id^="usp-drawer-id-"]:not([style*="display: none"])'
  );
  if (!activeDrawer) return;

  const focusable = getFocusableElements(activeDrawer);
  if (focusable.length === 0) return;

  const firstEl = focusable[0];
  const lastEl = focusable[focusable.length - 1];

  if (e.key === "Tab") {
    if (e.shiftKey) {
      if (document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      if (document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  }
}

function handleEscapeKey(e) {
  if (e.key === "Escape") {
    toggleUspDrawer(false);
  }
}
